<template>
  <transition name="fade">
    <div v-if="current" class="pum-backdrop" @click.self="close">
      <div class="pum-dialog" role="dialog" aria-modal="true">
        <div class="pum-header">
          <span class="pum-badge">{{ copy.badge }}</span>
          <span v-if="items.length > 1" class="pum-counter">{{ position + 1 }} {{ copy.of }} {{ items.length }}</span>
          <button type="button" class="pum-close" :aria-label="copy.close" @click="close">&times;</button>
        </div>
        <h3 class="pum-title">{{ current.title }}</h3>
        <p class="pum-summary">{{ current.summary }}</p>
        <ol class="pum-steps">
          <li v-for="(step, index) in current.steps" :key="stepKey(index)">
            <span>{{ step.text }}</span>
            <portal-update-step-images :urls="step.image_urls || []" :alt="step.text" />
          </li>
        </ol>
        <div class="pum-actions">
          <button type="button" class="pum-btn pum-btn-secondary" @click="acknowledge">{{ copy.acknowledge }}</button>
          <button v-if="current.target_route" type="button" class="pum-btn pum-btn-primary" @click="goToModule">{{ copy.goToModule }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import PortalUpdateStepImages from './PortalUpdateStepImages.vue';

const COPY = {
  badge: '✨ Novedad',
  of: 'de',
  close: 'Cerrar',
  acknowledge: 'Entendido',
  goToModule: 'Ir al módulo →',
};
const FIRST_POSITION = 0;
const NEXT_STEP = 1;

export default {
  name: 'PortalUpdateModal',
  components: { PortalUpdateStepImages },
  props: {
    items: { type: Array, default: () => [] },
  },
  data() {
    return { position: FIRST_POSITION, copy: COPY };
  },
  computed: {
    current() {
      return this.items[this.position] || null;
    },
  },
  watch: {
    items() {
      this.position = FIRST_POSITION;
    },
  },
  methods: {
    stepKey(index) {
      return `${this.current.id}-${index}`;
    },
    close() {
      this.$emit('close');
    },
    acknowledge() {
      this.$store.dispatch('portalUpdates/markRead', this.current.id);
      if (this.position + NEXT_STEP < this.items.length) {
        this.position += NEXT_STEP;
        return;
      }
      this.close();
    },
    goToModule() {
      const route = this.current.target_route;
      this.$store.dispatch('portalUpdates/markRead', this.current.id);
      this.close();
      if (this.$route.path !== route) this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.pum-backdrop { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center; z-index: 1060; padding: 16px; }
.pum-dialog { background: #fff; border-radius: 12px; width: 100%; max-width: 560px; max-height: 90vh; overflow-y: auto; padding: 24px; }
.pum-header { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
.pum-badge { color: #01662E; font-weight: 600; }
.pum-counter { color: #6b6b6b; font-size: 14px; margin-left: auto; }
.pum-close { background: none; border: none; font-size: 24px; line-height: 1; cursor: pointer; color: #6b6b6b; }
.pum-title { color: #2d2d2d; margin-bottom: 8px; }
.pum-summary { color: #4a4a4a; }
.pum-steps { padding-left: 20px; margin: 16px 0; }
.pum-steps li { margin-bottom: 12px; }
.pum-actions { display: flex; justify-content: flex-end; gap: 12px; flex-wrap: wrap; }
.pum-btn { border-radius: 8px; padding: 10px 18px; font-weight: 600; cursor: pointer; border: 1px solid #01662E; }
.pum-btn-secondary { background: #fff; color: #01662E; }
.pum-btn-primary { background: #01662E; color: #fff; }
@media (max-width: 576px) { .pum-dialog { max-height: 100vh; border-radius: 0; } .pum-actions { flex-direction: column-reverse; } .pum-btn { width: 100%; } }
</style>
